import moment from 'moment';

export default function getISODateOrTodaysISODate(dateString: string | undefined) {
  return dateString ? moment(dateString).toISOString() : moment().toISOString();
}
